<!-- prettier-ignore -->

<div class="route-footer" [ngClass]="{'no-touch': disableTouch()}" >
    <button class="route-footer__toggleview" (click)="toggleView()">
        @if(showTimeline()){
            <div style="min-width: 60px; display: flex; align-items: center; justify-content: flex-start; font-size: 14px; padding: 0 12px;">
                <span>{{'Mostrar Mapa' | translate}}</span>
            </div>

            <div style="min-width: 35px; display: flex; align-items: center; justify-content: flex-end; font-size: 26px; padding-right: 10px;">
                <ion-icon style="fill: #fff;" name="map"></ion-icon>
            </div>
        }
        @else {
            <div style="min-width: 60px; display: flex; align-items: center; justify-content: flex-end; font-size: 14px; padding: 0 12px;">
                <span>{{'Mostrar Timeline' | translate}}</span>
            </div>        
            <div style="min-width: 35px; display: flex; align-items: center; justify-content: flex-end; font-size: 26px; padding-right: 10px;">
                <ion-icon style="fill: #fff;" name="grid"></ion-icon>
            </div>        
        }
    </button>

    @if (!isTechEditMode() && !isTechMode()){
        @if(!isLoadFromApi()){
            @if(authService.user()){
                <button (click)="sendRoute()" class="route-footer__endpoint">
                    <div style="min-width: 60px; display: flex; align-items: center; justify-content: flex-start; font-size: 14px; padding: 0 12px;">
                        <span>{{'Guardar Ruta' | translate}}</span>
                    </div>
            
                    <div style="min-width: 35px; display: flex; align-items: center; justify-content: flex-end; font-size: 26px; padding-right: 10px;">
                        <ion-icon style="fill: #fff;" name="save"></ion-icon>
                    </div>
                </button>        
            }
            @else{
                <button (click)="sendRoute()" class="route-footer__endpoint">
                    <div style="min-width: 60px; display: flex; align-items: center; justify-content: flex-start; font-size: 14px; padding: 0 12px;">
                        <span>{{'Enviar Ruta' | translate}}</span>
                    </div>
            
                    <div style="min-width: 35px; display: flex; align-items: center; justify-content: flex-end; font-size: 26px; padding-right: 10px;">
                        <ion-icon style="fill: #fff;" name="mail"></ion-icon>
                    </div>
                </button>        
            }
        }
        @else {
            <button (click)="sendRoute()" class="route-footer__endpoint">
                <div style="min-width: 60px; display: flex; align-items: center; justify-content: flex-start; font-size: 14px; padding: 0 12px;">
                    <span>{{'Detalles Ruta' | translate}}</span>
                </div>
        
                <div style="min-width: 35px; display: flex; align-items: center; justify-content: flex-end; font-size: 26px; padding-right: 10px;">
                    <ion-icon style="fill: #fff;" name="info"></ion-icon>
                </div>
            </button>        
        }
    }

</div>